import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    const run = async () => {
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        window.history.replaceState(null, "", "/account");
        navigate("/account", { state: { user: r.data }, replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    };
    run();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#2D1B36] flex items-center justify-center" data-testid="auth-callback">
      <p className="font-serif-d italic text-2xl text-[#DFCA9B]">Signing you in…</p>
    </div>
  );
}
